import { memo } from "react";
import {
  ArrowRight,
  CheckCircle2,
  Clock,
  Compass,
  FileText,
} from "lucide-react";
import { Button } from "@/components/ui/button";
import { StatChip } from "./StatChip";
import { truncate } from "./constants";

function HeroWelcomeBase({
  firstName,
  completedItems,
  totalItems,
  serviceAreaComplete,
  nextItem,
  onContinue,
}) {
  return (
    <div>
      <h1
        className="font-display text-5xl md:text-6xl font-extrabold tracking-tighter leading-[0.98] text-[#1A0F0A]"
        data-testid="dashboard-greeting"
      >
        Welcome,{" "}
        <span className="text-[#6B0F1A]">{firstName}</span>.
      </h1>
      <p className="text-[#4D3F35] mt-5 max-w-xl leading-relaxed text-[15px]">
        Work through the checklist below. Some documents just need a review, others require your signature.
        Set your service area to finish onboarding.
      </p>

      {/* Stat chips — stacked column on mobile, single row on desktop */}
      <div
        className="flex flex-col sm:flex-row items-stretch gap-2.5 mt-8 sm:flex-wrap md:flex-nowrap md:overflow-x-auto pb-1 -mx-1 px-1 [&::-webkit-scrollbar]:hidden [scrollbar-width:none]"
        data-testid="hero-stats"
      >
        <StatChip
          icon={FileText}
          label="Documents"
          value={`${completedItems}/${totalItems}`}
          tone="primary"
        />
        <StatChip
          icon={Compass}
          label="Service Area"
          value={serviceAreaComplete ? "Confirmed" : "Pending"}
          tone={serviceAreaComplete ? "gold" : "muted"}
        />
        {nextItem ? (
          <StatChip
            icon={Clock}
            label="Next up"
            value={truncate(nextItem.title, 28)}
            tone="muted"
          />
        ) : (
          <StatChip
            icon={CheckCircle2}
            label="Checklist"
            value="All items done"
            tone="primary"
          />
        )}
      </div>

      {/* Continue onboarding CTA — jumps to the next unfinished spot */}
      {(nextItem || !serviceAreaComplete) && (
        <Button
          onClick={onContinue}
          data-testid="continue-onboarding-btn"
          className="mt-5 bg-[#6B0F1A] hover:bg-[#8A1424] text-[#F5EBD9] font-bold text-sm tracking-wide rounded-sm btn-primary-glow btn-shine-loop group"
        >
          {nextItem ? "Continue onboarding" : "Confirm service area"}
          <ArrowRight className="w-4 h-4 ml-2 transition-transform group-hover:translate-x-0.5" strokeWidth={2.25} />
        </Button>
      )}
    </div>
  );
}

export const HeroWelcome = memo(HeroWelcomeBase);
